<section id="page-title">
    <div class="container">
        <div class="page-title">
            <h1>Prodotti</h1>
        </div>
        <!-- <div class="breadcrumb">
            <ul>
                <li><a href="#">Home</a>
                </li>
                <li><a href="#">Categoria macro</a>
                </li>
                <li class="active"><a href="#">Nome della categoria</a>
                </li>
            </ul>
        </div> -->
    </div>
</section>

<section id="page-content" class="sidebar-left">
    <div class="container-fluid">
        <div class="row">
            <!-- Content-->
            <div class="content col-lg-12">
                <!-- div class="row m-b-20">
                    <div class="col-lg-6 p-t-10 m-b-20">
                        <h3 class="m-b-20">Titolo categoria</h3>
                        <p>Breve descrizione della categoria, non è obbligatoria, ma potrebbe essere utile..</p>
                    </div>
                    <div class="col-lg-3">
                        <div class="order-select">
                            <h6>Sort by</h6>
                            <p>Showing 1&ndash;12 of 25 results</p>
                            <form method="get">
                                <select class="form-control">
                                    <option selected="selected" value="order">Default sorting</option>
                                    <option value="popularity">Sort by popularity</option>
                                    <option value="rating">Sort by average rating</option>
                                    <option value="date">Sort by newness</option>
                                    <option value="price">Sort by price: low to high</option>
                                    <option value="price-desc">Sort by price: high to low</option>
                                </select>
                            </form>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="order-select">
                            <h6>Sort by Price</h6>
                            <p>From 0 - 190$</p>
                            <form method="get">
                                <select class="form-control">
                                    <option selected="selected" value="">0$ - 50$</option>
                                    <option value="">51$ - 90$</option>
                                    <option value="">91$ - 120$</option>
                                    <option value="">121$ - 200$</option>
                                </select>
                            </form>
                        </div>
                    </div>
                </div -->
                <!--Product list-->
                <div class="shop">
                    
                        
                    <ng-container *ngIf="arrProdotti.length > 0 ">
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <div class="form-group">
                                    <!-- <span class="pull-right totProd"> di {{totProd}} Prodotti</span> -->
                                    <select [(ngModel)]="limitProd" style="width: 150px" class="form-control pull-right" (change)='setLimit()'>
                                <option value="60">60</option>
                                <option value="99">99</option>
                                <option value="120">120</option>
                                <option value="198">198</option>
                                <option value="297">297</option>
                              </select>
                                    <label for="tipo" class="control-label col-sm-4 pull-right">Visualizza</label>
                             
                                  </div>
                               <!--  <label class="">Visuallizza</label>
                                <select placeholder="Telefono"  [(ngModel)]="limit" class="form-control">
                                    <option>20</option>
                                </select> -->
                            </div>
                            <div class="col-12 col-md-4">
                        <!-- Pagination -->
                            <ul class="pagination">
                                <li class="page-item" *ngIf="pag > 1"><a class="page-link" (click)="getPage(1)">First</a></li>
                                <li class="page-item" *ngIf="pag > 1"><a class="page-link" (click)="prevPage()"><span class="material-icons icoNav">
                                    navigate_before
                                    </span></a></li>
                                <ng-container *ngFor="let page of pager.pages">
                                
                                    <li class="page-item" [ngClass]="{'active': pag == page}"><a class="page-link" (click)="getPage(page)" >{{page}}</a></li>
                                </ng-container>
                                
                                
                                
                                
                                <li class="page-item" *ngIf="pag < totPage"><a class="page-link" (click)="nextPage()"><span class="material-icons icoNav">
                                    navigate_next
                                    </span></a></li>
                                    <li class="page-item" *ngIf="pag < totPage"><a class="page-link" (click)="getPage(totPage)">Last</a></li>
                            </ul>
                            <!-- end: Pagination -->
                        </div>
                    </div>
                        <app-prodotti2 [arrProdotti]="arrProdotti" [titolo]="titoloProd" [numCol]="3" (sortClick)="sortProdotti($event)"></app-prodotti2>
                           
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <div class="form-group">
                                    <!-- <span class="pull-right totProd"> di {{totProd}} Prodotti</span> -->
                                    <select [(ngModel)]="limitProd" style="width: 150px" class="form-control pull-right" (change)='setLimit()'>
                                <option value="60">60</option>
                                <option value="99">99</option>
                                <option value="120">120</option>
                                <option value="198">198</option>
                                <option value="297">297</option>
                              </select>
                                    <label for="tipo" class="control-label col-sm-4 pull-right">Visualizza</label>
                             
                                  </div>
                               <!--  <label class="">Visuallizza</label>
                                <select placeholder="Telefono"  [(ngModel)]="limit" class="form-control">
                                    <option>20</option>
                                </select> -->
                            </div>
                            <div class="col-12 col-md-4">
                                <!-- Pagination -->
                                <ul class="pagination">
                                    <li class="page-item" *ngIf="pag > 1"><a class="page-link" (click)="getPage(1)">First</a></li>
                                    <li class="page-item" *ngIf="pag > 1"><a class="page-link" (click)="prevPage()"><span class="material-icons icoNav">
                                        navigate_before
                                        </span></a></li>
                                    <ng-container *ngFor="let page of pager.pages">
                                    
                                        <li class="page-item" [ngClass]="{'active': pag == page}"><a class="page-link" (click)="getPage(page)" >{{page}}</a></li>
                                    </ng-container>
                                    
                                    
                                    
                                    
                                    <li class="page-item" *ngIf="pag < totPage"><a class="page-link" (click)="nextPage()"><span class="material-icons icoNav">
                                        navigate_next
                                        </span></a></li>
                                        <li class="page-item" *ngIf="pag < totPage"><a class="page-link" (click)="getPage(totPage)">Last</a></li>
                                </ul>
                                <!-- end: Pagination -->
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="arrProdotti.length == 0">
                        <p>{{messaggio}}</p>
                    </ng-container>
                    
                </div>
                <!--End: Product list-->
            </div>
            <!-- end: Content-->
            <!-- Sidebar-->
           <!--  <div class="sidebar col-lg-3">
             
                <div class="widget clearfix widget-archive">  
               
                <h4 class="widget-title">Categorie prodotti</h4>

                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                    
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                    
                    <a (click)="searchCat(node.idcat, node.level)" class="listCat">{{node.name}}</a>
                    
                    
                    </mat-tree-node>
                   
                    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
                    
                    <h5 class="ac-title listCat">{{node.name}}</h5>

                    <button class="btnExpand" mat-icon-button matTreeNodeToggle
                            [attr.aria-label]="'Toggle ' + node.name">
                        <mat-icon class="mat-icon-rtl-mirror">
                        {{treeControl.isExpanded(node) ? 'remove' : 'add'}}
                        </mat-icon>
                    </button>
                    </mat-tree-node>
                </mat-tree>
            
            
            </div> 
            
               
                
              
            </div> -->

        </div>
    </div>
</section>